import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import EditorPicks from './components/EditorPicks';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '桃桃漫画网 - 韩国漫画无删减免费在线阅读',
  description: '桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读资源多样，下拉操作轻松，让您免费畅享无删减韩国可爱漫画的内容。',
  url: 'https://www.taotao-comic.com',
  inLanguage: 'zh-CN',
  isPartOf: {
    '@type': 'WebSite',
    name: '桃桃漫画网',
    url: 'https://www.taotao-comic.com',
  },
  about: {
    '@type': 'Organization',
    name: '桃桃漫画网',
    url: 'https://www.taotao-comic.com',
    description: '韩国漫画无删减下拉式免费在线漫画阅读平台',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩国漫画无删减漫画下拉式-免费韩漫在线阅读-桃桃漫画网"
        description="桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读资源多样，下拉操作轻松，让您免费畅享无删减韩国可爱漫画的内容。"
        keywords="韩国漫画,无删减漫画,下拉式漫画,免费韩漫,在线阅读,桃桃漫画网"
        canonicalUrl="https://www.taotao-comic.com"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedGrid />
        <EditorPicks />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}